module.exports = __webpack_public_path__ + "static/media/bottomSearch.1f0cebde.svg";